var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnShare24 = function SvgLightIcnShare24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 4.243 8.854 6.889a.5.5 0 1 1-.708-.707l3.407-3.407a.5.5 0 0 1 .465-.275.5.5 0 0 1 .371.146l3.536 3.536a.5.5 0 1 1-.708.707L12.5 4.172V15a.5.5 0 0 1-1 0zm5.073 6.27a.5.5 0 0 1-.003-1l2.76-.01c.636-.002 1.168.487 1.17 1.112v8.772c0 .626-.53 1.116-1.167 1.116H4.667c-.636 0-1.167-.49-1.167-1.116v-8.769c0-.625.53-1.115 1.167-1.115l2.763.01a.5.5 0 0 1-.003 1l-2.76-.01c-.1 0-.167.061-.167.115v8.77c0 .054.066.115.167.115h14.666c.1 0 .167-.061.167-.116v-8.769c0-.054-.067-.115-.167-.115z",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnShare24;